export const getInitialCompetitionValues = date => ({
  type: 'INSTAGRAM_COMPETITION',
  status: 'draft',
  startDate: date,
  endDate: date,
  actions: [
    {
      failure: [],
      success: [
        {
          type: 'Send Instagram Comment Reply'
        },
        {
          type: 'Google Sheet Append',
          action: 'GOOGLE_SHEET_APPEND',
          sheetUrl: '',
          row: ''
        }
      ],
      triggers: [
        {
          type: 'Comments On Post'
        },
        {
          type: 'Match Hashtag',
          value: []
        }
      ],
      platform: 'instagram',
      description: 'Opt-In',
      operator: 'all'
    }
  ],
  moderated: false,
  moderators: { handles: [] },
  automated: false,
  threshold: 20,
  enableFiltering: false,
  enableBlastFiltering: false,
  store: false,
  profanity: false,
  lock: false
})



// WEBPACK FOOTER //
// ./src/pages/widgets/competition/create/container/initialValues.js